<template>
  <header class="header">
    <div class="header__content">
      <router-link
        :to="{ name: logoRoute }"
        class="header__logo-link"
      >
        <img
          alt="Claussen-Simon-Stiftung Logo"
          class="header__logo header__logo--large"
          height="65"
          src="@/assets/logo.svg"
          width="350"
        >
        <img
          alt="Claussen-Simon-Stiftung Logo"
          class="header__logo header__logo--icon"
          height="35"
          src="@/assets/icon.svg"
          width="35"
        >
      </router-link>

      <div
        v-if="loggedIn"
        class="header__nav"
      >
        <router-link
          v-if="$is([$config.groups.ADMIN])"
          :to="{ name: 'registration-list' }"
          class="header__link"
        >
          Registrierungen
        </router-link>

        <router-link
          v-if="$is([$config.groups.ADMIN, $config.groups.COACH, $config.groups.COACHEE])"
          :to="{ name: 'coaching-list' }"
          class="header__link"
        >
          Coachings
        </router-link>

        <router-link
          v-if="$is([$config.groups.ADMIN, $config.groups.COACHEE])"
          :to="{ name: 'coach-list' }"
          class="header__link"
        >
          Coaches
        </router-link>

        <router-link
          v-if="$is([$config.groups.ADMIN])"
          :to="{ name: 'coachee-list' }"
          class="header__link"
        >
          Coachees
        </router-link>

        <router-link
          v-if="$is([$config.groups.ADMIN, $config.groups.COACH, $config.groups.COACHEE])"
          :to="{ name: 'account' }"
          class="header__link"
        >
          Konto
        </router-link>

        <button
          class="header__link"
          @click="logout"
        >
          Abmelden
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import api from '@/api'

export default {
  name: 'SHeader',

  computed: {
    loggedIn () {
      return this.$store.state.user.meta.id
    },
    logoRoute () {
      return this.$config.defaultRoute[this.$store.state.user.meta.group]
    }
  },

  methods: {
    logout () {
      api.auth
        .logout()
        .then(() => {
          this.$notify.success({
            title: 'Abgemeldet',
            message: 'Sie wurden erfolgreich abgemeldet.'
          })

          this.$router.push({ name: 'login' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  padding: 1rem 0;

  @media (min-width: 45rem) {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

.header__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: $--container-width;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 $--container-padding;

  @media (min-width: 45rem) {
    align-items: flex-end;
  }
}

.header__logo-link {
  flex-shrink: 0;
}

.header__logo {
  vertical-align: middle;
}

.header__logo--large {
  display: none;
}

@media (min-width: 45rem) {
  .header__logo--large {
    display: inline;
  }

  .header__logo--icon {
    display: none;
  }
}

.header__nav {
  margin-left: 2rem;

  text-align: right;
  line-height: 1.6;
}

.header__link {
  display: inline-block;
  padding: 0;
  margin-left: 1em;

  font-size: 1em;
  text-decoration: none;
  line-height: inherit;
  color: $--color-text-primary;

  background: none;
  border: 0;

  &:hover,
  &.is-active-route {
    text-decoration: underline;
    color: $--color-primary;
  }
}
</style>
